import { render } from "./CarImagesEdit.vue?vue&type=template&id=e96983a8"
import script from "./CarImagesEdit.vue?vue&type=script&lang=js"
export * from "./CarImagesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__